module.exports = __webpack_public_path__ + "media/assets_v3/images/store-message-warn-mobile-a7f1eea483979708e9c67627c4ca9125.jpg";